import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FranchiseeDataForm } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AddFranchisee = function AddFranchisee(_ref) {
  var history = _ref.history;
  return ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(FranchiseeDataForm, {
    onSubmit: function onSubmit() {
      return history.push('/franchises');
    }
  })));
};

AddFranchisee.propTypes = {
  history: PropTypes.object
};
export default AddFranchisee;